export { BRANDS_ARRAY, BRANDS_MOTO_ARRAY, translateBrand, translateBrandToSlug, findBrand, findBrandByName } from "./brand/Brand";
export { MODELS_ARRAY, translateModel, translateModelToSlug, findModel, findModelByName, getModelsWithBrand } from "./model/Model";
import { COMFORT_ARRAY, SECURITY_ARRAY, MULTIMEDIA_ARRAY, ASSISTANT_ARRAY, findTypeOfEquipment } from "./equipment/Equipment";
export { COMFORT_ARRAY, SECURITY_ARRAY, MULTIMEDIA_ARRAY, ASSISTANT_ARRAY, findTypeOfEquipment };
import { GEAR_ARRAY, FUEL_ARRAY, FINANCE_ARRAY, CAPACITY_ARRAY, COURSE_ARRAY, POWER_ARRAY, YEAR_ARRAY, INVOICE_ARRAY, BODY_TYPE_TRUCK_ARRAY, BODY_TYPE_CAR_ARRAY, PRICE_TYPE_ARRAY, PRICE_ARRAY, STATES_ARRAY, PRODUCT_TYPES_ARRAY, PRICE_TYPES_ARRAY, COUNTRY_ARRAY, COLORS_ARRAY, COLOR_TYPES_ARRAY, GEAR_MOTO_ARRAY, FUEL_MOTO_ARRAY, BODY_TYPE_MOTO_ARRAY } from "./other/Other";
export { GEAR_ARRAY, FUEL_ARRAY, FINANCE_ARRAY, CAPACITY_ARRAY, COURSE_ARRAY, POWER_ARRAY, YEAR_ARRAY, INVOICE_ARRAY, BODY_TYPE_TRUCK_ARRAY, BODY_TYPE_CAR_ARRAY, PRICE_TYPE_ARRAY, PRICE_ARRAY, STATES_ARRAY, PRICE_TYPES_ARRAY, PRODUCT_TYPES_ARRAY, COUNTRY_ARRAY, COLORS_ARRAY, COLOR_TYPES_ARRAY, GEAR_MOTO_ARRAY, FUEL_MOTO_ARRAY, BODY_TYPE_MOTO_ARRAY }
import { STATUSES_ARRAY } from "./profile/Profile";
export { STATUSES_ARRAY };

const STRING_ARRAYS = STATES_ARRAY.concat(INVOICE_ARRAY)
    .concat(PRODUCT_TYPES_ARRAY)
    .concat(PRICE_TYPES_ARRAY)
    .concat(FINANCE_ARRAY)
    .concat(GEAR_ARRAY)
    .concat(FUEL_ARRAY)
    .concat(BODY_TYPE_CAR_ARRAY)
    .concat(BODY_TYPE_TRUCK_ARRAY)
    .concat(PRICE_TYPE_ARRAY)
    .concat(COUNTRY_ARRAY)
    .concat(COMFORT_ARRAY)
    .concat(SECURITY_ARRAY)
    .concat(MULTIMEDIA_ARRAY)
    .concat(ASSISTANT_ARRAY)
    .concat(COLORS_ARRAY)
    .concat(COLOR_TYPES_ARRAY)
    .concat(GEAR_MOTO_ARRAY)
    .concat(FUEL_MOTO_ARRAY)
    .concat(BODY_TYPE_MOTO_ARRAY)
    .concat(STATUSES_ARRAY)

export const findOther = (slug: string) => {
    const arr = STRING_ARRAYS
    return arr.find(el => el[1] === slug) || ["", ""]
}

export const translate = (str:string) => {
    const tmp = STRING_ARRAYS.find(el => el[1] === str)
    if (tmp) {
        return tmp[0]
    }
    return str
}
